import {
    EMPTY_PROJECT_CTA,
    EMPTY_RANK_TRACKER_CTA,
    EMPTY_TOPIC_CTA,
} from "app/pages/activation/components/HomeWithData/ShareData/TrafficWidgets/RankTracker/texts";
import type { RankTrackerEmptyState } from "app/pages/activation/components/HomeWithData/ShareData/TrafficWidgets/types";

export const EMPTY_VALUE = 12.4;
export const EMPTY_CHANGE_VALUE = "1.2";

export const EMPTY_MOVED_UP_VALUE = 5;
export const EMPTY_DECLINING_VALUE = 3;

export const EMPTY_STATE_CTA_KEY: Record<RankTrackerEmptyState, string> = {
    noProject: EMPTY_PROJECT_CTA,
    noTopics: EMPTY_TOPIC_CTA,
    noRankTracker: EMPTY_RANK_TRACKER_CTA,
    scraping: "",
};
